import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { AccessCodeService } from '../access-code.service';
import { AccessCode } from '../access-code';
import { AccessCodeComponent } from '../access-code/access-code.component';

@Component({
    selector: 'app-access-code-list',
    templateUrl: './access-code-list.component.html',
    styleUrls: ['./access-code-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class AccessCodeListComponent implements OnInit {
	accessTypes: any[]=[];
	accessStatuses: any[]=[];
	lockLocations: any[]=[];
	constructor(
		private accessCodeService: AccessCodeService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = accessCodeService.statuses;
		this.accessTypes = accessCodeService.accessTypes;
		this.accessStatuses = accessCodeService.accessStatuses;
		this.lockLocations = accessCodeService.lockLocations;
	}



	// data
	@Input() reservationId: any;
	@Input() reservation: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	accessCodes: any;
	accessCode: AccessCode;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'accessCodeId', header: 'Id', width: 'auto' },
		{ field: 'accessCode', header: 'Access Code', width: 'auto' },
		{ field: 'startDate', header: 'Start Date', width: 'auto' },
		{ field: 'endDate', header: 'End Date', width: 'auto' },
		{ field: 'lockLocation', header: 'Lock Location', width: 'auto' },
		{ field: 'kabaStatus', header: 'Kaba Status', width: 'auto' },
		{ field: 'accessType', header: 'Access Type', width: 'auto' },
		{ field: 'doorName', header: 'Door Name', width: 'auto' },
		{ field: 'shortTermRentalVO.propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'shortTermRentalId', header: 'Str #', width: 'auto' },
		{ field: 'reservationId', header: 'Res #', width: 'auto' },
		{ field: 'logger', header: 'Logger', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.accessCodeId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-accessCode-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if (this.reservationId) {
				// show only reservations that are assigned to this reservationId
				let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.accessCodeService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.accessCodes = res.data.accessCodes;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.accessCodes = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(accessCode: AccessCode) {
		try {
			this.formLoading = true;
			this.accessCodeService.update(accessCode)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.accessCodes.map((accessCode, i) => {
							if (accessCode.accessCodeId === res.data.accessCode.accessCodeId) {
								this.accessCodes[i] = res.data.accessCode;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(accessCode: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(accessCode));

			this.formLoading = true;
			this.accessCodeService.delete(accessCode.accessCodeId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.accessCodes.splice(this.accessCodes.indexOf(accessCode), 1);
						this.recordTotal = this.accessCodes.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'AccessCode ' + accessCode.accessCodeId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'AccessCode ' + accessCode.accessCodeId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";
		dialogConfig.height = "55vh";
		dialogConfig.maxHeight = "100vh";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Access Code',
			reservation: this.reservation,
			reservationId: this.reservationId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(AccessCodeComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addAccessCodeCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	getLockLocationName(accessCode: any) {
		if (accessCode?.lockLocation) {
			const lockLocation = this.lockLocations.find((e: any) => e.value == accessCode.lockLocation);
			return lockLocation.name;
		}
		else {
			return '';
		}
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(accessCode: AccessCode) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";
		dialogConfig.height = "55vh";
		dialogConfig.maxHeight = "100vh";

		// Keep API date strings as-is (no new Date()) so edit form matches grid — naive wall-clock, no TZ shift.
		const accessCodeData: AccessCode = { ...accessCode };
		dialogConfig.data = {
			accessCode: accessCodeData,
			title: 'Edit Access Code'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(AccessCodeComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateAccessCodeCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteAccessCodeCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addAccessCodeCB(accessCode: AccessCode) {
		console.log('Adding AccessCode: ' + JSON.stringify(accessCode));
		// if we don't have a accessCodes array yet...
		if (!this.accessCodes) {
			this.accessCodes = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.accessCodes.unshift(accessCode);

		// no idea what this is but it is required to update the array
		this.accessCodes = [...this.accessCodes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'AccessCode ' + accessCode.accessCodeId + ' Added', life: 3000 });
	}

	updateAccessCodeCB(accessCode: AccessCode) {
		console.log('Updating AccessCode: ' + JSON.stringify(accessCode));
		let itemIndex = this.accessCodes.findIndex((item: any) => item.accessCodeId === accessCode.accessCodeId);
		this.accessCodes[itemIndex] = accessCode;

		// no idea what this is but it is required to update the array
		this.accessCodes = [...this.accessCodes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'AccessCode ' + accessCode.accessCodeId + ' Updated', life: 3000 });
	}

	deleteAccessCodeCB(accessCode: AccessCode) {
		console.log('Removing AccessCode: ' + accessCode);
		this.accessCodes.splice(this.accessCodes.indexOf(accessCode), 1);
		this.recordTotal = this.accessCodes.length;

		// no idea what this is but it is required to update the array
		this.accessCodes = [...this.accessCodes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'AccessCode ' + accessCode.accessCodeId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.accessCodes ? this.first === (this.accessCodes.length - this.rows) : true; }
	isFirstPage(): boolean { return this.accessCodes ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(accessCode: any) {
		if (accessCode?.status) {
			const status = this.statuses.find((e: any) => e.value == accessCode.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getAccessTypeName(accessCode: any) {
		if (accessCode?.accessType) {
			const status = this.accessTypes.find((e: any) => e.value == accessCode.accessType);
			return status.name;
		}
		else {
			return '';
		}
	}

	getAccessStatusName(accessCode: any) {
		if (accessCode?.kabaStatus) {
			const status = this.accessStatuses.find((e: any) => e.value == accessCode.kabaStatus);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	formatAccessDateTime(val: any): string {
		if (val == null || val === '') {
			return '';
		}
		const s = typeof val === 'string' ? val : String(val);
		const dateOnly = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
		if (dateOnly) {
			return `${dateOnly[2]}/${dateOnly[3]}/${dateOnly[1]}`;
		}
		const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
		if (!m) {
			return s;
		}
		const y = m[1];
		const mo = m[2];
		const d = m[3];
		const hh = parseInt(m[4], 10);
		const mi = m[5];
		let h12 = hh % 12;
		if (h12 === 0) {
			h12 = 12;
		}
		const ampm = hh < 12 ? 'AM' : 'PM';
		return `${mo}/${d}/${y} ${String(h12).padStart(2, '0')}:${mi} ${ampm}`;
	}
}
